import { BaseService } from 'components/base/base-service';
import { apiService } from 'libs/axios/services';

export const deleteCollectionTasks = async (
    request: ICollectionTaskDeleteRequest,
): Promise<ApiResponse<any>> => {
    return apiService.delete<ICollectionTaskDeleteRequest, any>(
        '/collection-task/list',
        undefined,
        undefined,
        {
            headers: { 'Content-Type': 'application/json' },
            data: { task_ids: request.task_ids },
        },
        true,
    );
};

export const getStaffOptions = async (
    request: IGetListUserReq,
): Promise<ApiResponse<ResponseBase<IUserData[]>>> => {
    return apiService.get<IGetListUserReq, ResponseBase<IUserData[]>>('/user/options', request);
};

export const registerCollection = async (
    request: IRegisterCollectionRequest,
): Promise<ApiResponse<any>> => {
    return apiService.post<IRegisterCollectionRequest, any>('/collection-task/', request);
};

export const updateCollectionAPI = async (
    task_id: string,
    request: IUpdateCollectionRequest,
): Promise<ApiResponse<any>> => {
    return apiService.put<IUpdateCollectionRequest, any>(
        `/collection-task/${task_id}`,
        request,
        undefined,
        true,
    );
};

export abstract class ITransportTaskService extends BaseService<ITransportTaskTable> {}

export class TransportTaskService extends ITransportTaskService {
    notFoundMessage = 'Transport task not found';
    path = '/transport-task';

    getAll(
        _params?: TransportTaskRequest,
    ): Promise<ApiResponse<ResponseBase<ITransportTaskTable[]>>> {
        return apiService.get<TransportTaskRequest, ResponseBase<ITransportTaskTable[]>>(
            `${this.path}/list`,
            _params,
            undefined,
            true,
        );
    }

    getById(_id: string): Promise<any> {
        return apiService.get<string, any>(`${this.path}/${_id}`);
    }

    create(_data: Partial<ITransportTaskTable>): Promise<ITransportTaskTable> {
        throw new Error('Method not implemented.');
    }

    update(_id: string, _data: Partial<ITransportTaskTable>): Promise<ITransportTaskTable> {
        throw new Error('Method not implemented.');
    }

    deleteAll(_ids: string[]): Promise<ITransportTaskTable[]> {
        throw new Error('Method not implemented.');
    }

    deleteById(_id: string): Promise<void> {
        throw new Error('Method not implemented.');
    }

    downloadCSV(_params?: URLSearchParams): Promise<ApiResponse<any>> {
        throw new Error('Method not implemented.');
    }
}
